import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";
import { Tab } from "../../models/tabs.model";
import { filter } from "rxjs";

@Component({
  selector: "app-tabs",
  templateUrl: "./tabs.component.html",
  styleUrl: "./tabs.component.scss",
})
export class TabsComponent implements OnInit {
  @Input() tabs: Tab[] = []; // Tabs array passed from parent
  @Input() defaultTab!: string; // Default selected tab
  @Input() tabBackgroundColor = "#f9fafb";
  @Input() routingStyle = "hash";
  @Output() tabChanged = new EventEmitter<string>(); // Emit tab change event

  activeTab!: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    if (this.routingStyle == "hash") {
      this.route.fragment.subscribe((fragment) => {
        if (fragment && this.tabs.some((tab) => tab.name === fragment)) {
          this.activeTab = fragment;
        }
      });
    } else if (this.routingStyle == "path") {
      this.setActiveTabFromUrl(this.router.url);

      // ✅ Handle subsequent navigations
      this.router.events
        .pipe(filter((event) => event instanceof NavigationEnd))
        .subscribe((event) => {
          this.setActiveTabFromUrl(this.router.url);
        });
    } else {
      this.activeTab = this.defaultTab;
    }
  }

  private setActiveTabFromUrl(url: string) {
    const cleanUrl = url.split("#")[0];
    const lastSegment = cleanUrl.split("/").pop();
    if (
      lastSegment &&
      this.tabs.some(
        (tab) => tab.name.toLowerCase() === lastSegment.toLowerCase()
      )
    ) {
      this.activeTab = this.tabs.find(
        (tab) => tab.name.toLowerCase() === lastSegment.toLowerCase()
      )!.name;
    }
  }

  switchTab(tabName: string) {
    this.activeTab = tabName;
    // this.router.navigate([], { fragment: tabName }); // Update URL hash
    this.tabChanged.emit(tabName); // Emit tab change event
  }
}
